function checkGlobalKlaviyoObject() {
return typeof _learnq !== "undefined";
}

function isIdentified() {
    return document.cookie.includes('__kla_id');
}

function identifyCustomer(customer){
    if (!customer || !customer.email) return false;
    klaviyo.push(['identify', {
        '$email': customer.email,
        '$first_name': customer.first_name,
        '$last_name': customer.last_name
      }]);
    return true;
}

function klaviyoScreenRegistrationMetric(customer, eventName, data){
    const isCustomerIdentified = isIdentified();
     identifyCustomer(customer);
    klaviyo.push(['track', eventName, {
        'replacementId':data.register_productid,
        'replacementProductName':data.device_name,
        'replacementPurchaseLocation':data.purchase_location,
        'replacementPurchaseDate':data.purchase_date

      }]);
}

function klaviyoCaseRegistrationMetric(customer, eventName, data){
    const isCustomerIdentified = isIdentified();
     identifyCustomer(customer);
    klaviyo.push(['track', eventName, {
        'replacementCaseProductSku':data.register_productid,
        'replacementCasepurchaseLocation':data.purchase_location,
        'replacementCasepurchaseDate':data.purchase_date
      }]);
}

function klaviyoQrRegistrationMetric(customer, eventName, data, productTitle){
    const isCustomerIdentified = isIdentified();
     identifyCustomer(customer);
    klaviyo.push(['track', eventName, {
        'productId':data.register_productid,
        'siteID':data.purchase_location,
        'productName':productTitle

      }]);
}

window.KlaviyoEventsHelper = {
    checkGlobalKlaviyoObject,
    klaviyoScreenRegistrationMetric,
    klaviyoCaseRegistrationMetric,
    klaviyoQrRegistrationMetric,
}